import React from "react";
import { Typography, Box, Button } from "@material-ui/core";
import styles from "../styles";

function ADATitleIXNotificationText({ displayAccommodationTypes }) {
  const classes = styles();

  return (
    <>
      <Box style={{ marginBottom: "24px" }}>
        <Typography>
          This student is actively receiving accommodations through both the Student Accommodations Office and the Title IX Office, in accordance with University policies.
        </Typography>
      </Box>

      <Box style={{ marginBottom: "24px" }}>
        <Typography>
          <span style={{ fontWeight: "bold" }}>You are required to read this notification and click on the definitions below</span> to ensure you understand and implement the accommodations provided to the student.
        </Typography>
      </Box>

      <Box style={{ marginBottom: "24px" }}>
        <Typography component="h3" className={classes.subHeadingText}>
          Approved Accommodations:
        </Typography>
      </Box>

      <Box style={{ marginBottom: "24px" }}>
        <Typography className={classes.accomText}>
          {displayAccommodationTypes.length > 0 &&
            displayAccommodationTypes.map(
              (accommodation, index) => (
                <React.Fragment key={index}>
                  <Typography display="inline">
                    {accommodation && accommodation !== "null" && `${accommodation}${index < displayAccommodationTypes.length - 1 ? `; ` : ''}`}
                  </Typography>
                </React.Fragment>
              )
            )}
        </Typography>
      </Box>

      <Box className={classes.textBlock}>
        <Typography display="inline">
          {`Please also refer to the `}
          <Button
            href={process.env.REACT_APP_ACCOMMODATION_DICTIONARY_URL}
            target="_blank"
            className={classes.popUpLinkText}
            disableRipple
          >
            {`Accommodations Dictionary`}
          </Button>
          {` for detailed resources that specifically address how to accommodate the student.`}
        </Typography>
      </Box>

      <Box className={classes.textBlock}>
        <Typography component="ul" style={{ paddingLeft: "20px", margin: 0 }}>
          <li style={{ marginBottom: "12px" }}>
            <Typography display="inline">
              The Faculty Responsibilities sections outline what you are required to do to implement the accommodations effectively under both{" "}
              <Button
                href={`${process.env.REACT_APP_ACCOMMODATION_DICTIONARY_URL}#Faculty-Responsibilities-ADA`}
                target="_blank"
                className={classes.popUpLinkText}
                disableRipple
              >
                ADA
              </Button>
              {" and "}
              <Button
                href={`${process.env.REACT_APP_ACCOMMODATION_DICTIONARY_URL}#Faculty-Responsibilities-Title-IX`}
                target="_blank"
                className={classes.popUpLinkText}
                disableRipple
              >
                Title IX
              </Button>
              .
            </Typography>
          </li>
          <li style={{ marginBottom: "12px" }}>
            <Typography display="inline">
              {`The `}
              <Button
                href={`${process.env.REACT_APP_ACCOMMODATION_DICTIONARY_URL}#Setting-Up-Accommodations-In-Blackboard`}
                target="_blank"
                className={classes.popUpLinkText}
                disableRipple
              >
                {`Setting Up Accommodations in Blackboard`}
              </Button>
              {` section includes instructions for how to note on the roster this student is receiving accommodations in the course.`}
            </Typography>
          </li>
          <li>
            <Typography display="inline">
              <Button
                href={`${process.env.REACT_APP_ACCOMMODATION_DICTIONARY_URL}#Communication-Strategies`}
                target="_blank"
                className={classes.popUpLinkText}
                disableRipple
              >
                Communication Strategies
              </Button>
              {" provide best practices for ensuring both you and the student are engaged in the process."}
            </Typography>
          </li>
        </Typography>
      </Box>

      <Box className={classes.textBlock}>
        <Typography display="inline">
          {`The student can also access this information in the `}
          <Button
            href={process.env.REACT_APP_STUDENT_ACCOMMODATION_DICTIONARY_URL}
            target="_blank"
            className={classes.popUpLinkText}
            disableRipple
          >
            {`Student Accommodations Dictionary`}
          </Button>
          {`, available in the Knowledgebase located in My Phoenix (provided for reference).`}
        </Typography>
      </Box>

      <Box className={classes.textBlock}>
        <Typography display="inline">
          Any information pertaining to the student's accommodations must remain private. The reason the student qualifies for accommodations will not be disclosed, as this information is not necessary to implement the accommodations.
        </Typography>
      </Box>

      <Box className={classes.textBlock}>
        <Typography display="inline">
          If you have any questions, please do not hesitate to contact the appropriate office:
        </Typography>
      </Box>

      <Box className={classes.textBlock}>
        <Typography display="inline">
          {`Student Accommodations Office at `}
          <a href="mailto:SAO@phoenix.edu" style={{ color: "#30718D", textDecoration: "underline" }}>
            SAO@phoenix.edu
          </a>
        </Typography>
      </Box>

      <Box className={classes.textBlock}>
        <Typography display="inline">
          {`Title IX Office at `}
          <a href="mailto:Title.IXUOP@phoenix.edu" style={{ color: "#30718D", textDecoration: "underline" }}>
            Title.IXUOP@phoenix.edu
          </a>
        </Typography>
      </Box>

      <Box className={classes.textBlock}>
        <Typography display="inline">
          If you are unsure who to contact, please copy both offices on any communication.
        </Typography>
      </Box>

      <Box className={classes.textBlock}>
        <Typography display="inline">
          Thank you for all you do to support our students!
        </Typography>
      </Box>
    </>
  );
}

export default ADATitleIXNotificationText;
